import { IModel, Model, ModelRecord } from "./Model";

export interface IFollowUpAppointmentModel extends IModel {
    followUpBookingURL:string;
    clinetFirstname: string;
    clinetLastName: string;
    clinetCellPhone: string;
    clinetEmailAddress: string;
    petname: string;
    petspecies: string;
    isreturningcustomer: string;
    store_number: string;
    clinicZipCode: string;
}

export class FollowUpAppointmentModel extends Model implements ModelRecord<IFollowUpAppointmentModel>{
    followUpBookingURL:string;
    clinetFirstname: string;
    clinetLastName: string;
    clinetCellPhone: string;
    clinetEmailAddress: string;
    petname: string;
    petspecies: string;
    isreturningcustomer: string;
    store_number: string;
    clinicZipCode: string;

    constructor(params?: Partial<IFollowUpAppointmentModel>) {
        super(params);
        this.followUpBookingURL= _.defaultTo(params?.followUpBookingURL,"");
        this.clinetFirstname= _.defaultTo(params?.clinetFirstname,"");
        this.clinetLastName= _.defaultTo(params?.clinetLastName,"");
        this.clinetCellPhone= _.defaultTo(params?.clinetCellPhone,"");
        this.clinetEmailAddress= _.defaultTo(params?.clinetEmailAddress,"");
        this.petname= _.defaultTo(params?.petname,"");
        this.petspecies= _.defaultTo(params?.petspecies,"");
        this.isreturningcustomer= _.defaultTo(params?.isreturningcustomer,"");
        this.store_number= _.defaultTo(params?.store_number,"");
        this.clinicZipCode= _.defaultTo(params?.clinicZipCode,"");
    }

}
